import { useEffect, useReducer, useState } from "react";
import VariableTable from "./VariableTable";
import useAuthFetch from "../../hooks/useAuthFetch";

export default function AllVariables() {
  const customFetch = useAuthFetch();
  const [query, setQuery] = useState({});
  const [isReady, setIsReady] = useState(false);
  const [productType, setProductType] = useState("SINGLE");

  useEffect(() => {
    // Simulate query fetching and setting router readiness
    // const simulatedQuery = { param1: "value1", param2: "value2" }; // Replace with actual logic
    // setQuery(simulatedQuery);
    setIsReady(true);
  }, []);

  const handleChange = (event) => {
    setProductType(event.target.value);
  };

  function reducer(state, action) {
    switch (action.type) {
      case "LOADING":
        return { ...state, isLoading: true };

      case "UPDATE":
        return { ...state, response: action.payload, isLoading: false };

      case "ERROR":
        return { ...state, response: null, isLoading: false };

      default:
        throw new Error();
    }
  }

  const [state, dispatch] = useReducer(reducer, {
    response: null,
    isLoading: false,
  });

  const handleFetch = async () => {
    if (!isReady || state.isLoading) return;

    dispatch({ type: "LOADING" });

    const url = new URL(
      `${process.env.REACT_APP_API_URL}/v1/dashboard/variableMappings/fetchAll?productType=${productType}`
    );
    // url.search = new URLSearchParams(query).toString();
    // url.searchParams.append("withTranscription", "true");

    try {
      const method = "GET"
      const { response, status } = await customFetch(
        url,
        method,
      );

      if (status === 200) {
        dispatch({ type: "UPDATE", payload: response });
      } else {
        dispatch({ type: "ERROR" });
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: "ERROR" });
    }
  };

  useEffect(() => {
    handleFetch();
  }, [query, isReady, productType]);

  return (
    <div className="overflow-y-hidden">

      {isReady && (
        <>
          <VariableTable productType={productType} handleChange={handleChange} reqState={state} handleFetch={handleFetch} />{" "}
        </>
      )}
    </div>
  );
}
